import React from 'react';

/* Icons */
import CheckIcon from '~/../symbols/check.svg';

/* Common */
import { Icon } from '~/components/common';

export default function ConversionProgress({ steps, activeStep, setStep }) {
    const totalProgress = (100 / steps.length * activeStep.position);

    const isStepCompleted = (step) => {
        const activeStep = steps.find((step) => step.active);
        return step.position < activeStep.position;
    }

    const activateStep = (step) => {
        if (isStepCompleted(step)) {
            setStep(step);
        }
    }

    return (
        <div className="nav nav--progress">
            <div className="position-relative">
                <ul className="list list--steps mb-0">
                    {steps.map((step, index) => {
                        return (
                            <li key={index} className={`list__item ${step.position < activeStep.position ? "is-done" : ""} ${step.active ? "is-active" : ""}`} onClick={() => activateStep(step)}>
                                <p className="list__text text-truncate">
                                    {step.name}
                                </p>
                                <div className="list__progress">
                                    <Icon
                                        size={10}
                                        className={`btn__icon icon icon--lg-12`}
                                        url={CheckIcon?.url}
                                    />
                                </div>
                            </li>
                        )
                    })}
                </ul>
                <div className="nav nav--progressbar">
                    <div className="nav__bar" style={{ width: totalProgress + "%" }} />
                </div>
            </div>
        </div>
    )
}
